import { errors } from '@retailer-platform/dashboard/errors'
import { type RequestContext } from '../../types'

export function logRequest({
  retailerAppId,
  retailerId,
  requestContexts,
}: {
  retailerId: string
  retailerAppId?: string
  requestContexts: RequestContext[]
}) {
  errors.captureMessage('ordersOperationalDashboardContextError', {
    level: 'error',
    extra: {
      retailerId,
      retailerAppId,
      requestContexts,
    },
  })
}
